if (!customElements.get('watch-and-buy')) {
  class WatchAndBuy extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
      if (!this.track) return;

      this.addEventListener('click', this.onClick.bind(this));

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.scrollToCard(index));
      });

      let scrollScheduled = false;
      this.track.addEventListener(
        'scroll',
        () => {
          if (scrollScheduled) return;
          scrollScheduled = true;
          window.requestAnimationFrame(() => {
            this.updateDots();
            scrollScheduled = false;
          });
        },
        { passive: true }
      );

      this.bindDrag();
      this.observeVideos();
      this.updateDots();
    }

    scrollToCard(index) {
      const items = this.track.querySelectorAll('.watch-and-buy__item');
      const item = items[index];
      if (!item) return;
      this.track.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
    }

    updateDots() {
      if (!this.dots.length) return;
      const items = Array.from(this.track.querySelectorAll('.watch-and-buy__item'));
      if (!items.length) return;
      const trackCenter = this.track.scrollLeft + this.track.clientWidth / 2;
      let closestIndex = 0;
      let closestDistance = Infinity;
      items.forEach((item, index) => {
        const itemCenter = item.offsetLeft + item.getBoundingClientRect().width / 2;
        const distance = Math.abs(itemCenter - trackCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });
      this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === closestIndex));
    }

    bindDrag() {
      let isDown = false;
      let startX = 0;
      let startScroll = 0;
      let moved = false;

      this.track.addEventListener('mousedown', (event) => {
        isDown = true;
        moved = false;
        startX = event.pageX;
        startScroll = this.track.scrollLeft;
      });

      window.addEventListener('mouseup', () => {
        isDown = false;
      });

      window.addEventListener('mousemove', (event) => {
        if (!isDown) return;
        event.preventDefault();
        const delta = event.pageX - startX;
        if (Math.abs(delta) > 5) moved = true;
        this.track.scrollLeft = startScroll - delta;
      });

      this.track.addEventListener(
        'click',
        (event) => {
          if (moved) {
            event.preventDefault();
            event.stopPropagation();
          }
        },
        true
      );
    }

    observeVideos() {
      if (!('IntersectionObserver' in window)) return;

      const videos = this.querySelectorAll('.watch-and-buy__video');
      if (!videos.length) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (entry.isIntersecting) {
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.3 }
      );

      videos.forEach((video) => observer.observe(video));
    }

    onClick(event) {
      const button = event.target.closest('.watch-and-buy__mute');
      if (!button) return;
      event.preventDefault();

      const card = button.closest('.watch-and-buy__card');
      const video = card && card.querySelector('video');
      if (!video) return;

      video.muted = !video.muted;
      const isUnmuted = !video.muted;
      button.classList.toggle('is-unmuted', isUnmuted);
      button.setAttribute('aria-pressed', String(isUnmuted));
      button.setAttribute('aria-label', isUnmuted ? 'Mute video' : 'Unmute video');
    }
  }

  customElements.define('watch-and-buy', WatchAndBuy);
}
